// GA4-shape ecommerce pushes consumed by the Axon Pixel via Google Tag Manager.
//
// GTM listens for these `event` names (page_view, view_item, add_to_cart,
// begin_checkout, purchase) and forwards the `ecommerce` object to
// axon("track", ...). To add a new tracked event, push it here and create the
// matching Custom Event tag + trigger in GTM.
//
// `window.dataLayer` is initialised by the gtag.js snippet in public/index.html,
// so these pushes are safe in every environment (they simply accumulate on the
// dataLayer when GTM is not loaded, e.g. local/dev).

/**
 * @typedef {Object} AxonEcommerceItem
 * @property {string} item_id
 * @property {string} item_name
 * @property {number} price
 * @property {number} quantity
 * @property {string} [item_category]
 * @property {string} [item_variant]
 * @property {string} [item_brand]
 */

/**
 * @typedef {Object} AxonEcommercePayload
 * @property {string} [transaction_id]
 * @property {string} [currency]
 * @property {number} [value]
 * @property {number} [shipping]
 * @property {number} [tax]
 * @property {AxonEcommerceItem[]} [items]
 */

/**
 * Push a GA4-shape ecommerce event to the dataLayer for the Axon Pixel.
 * Resets `ecommerce` before every push so GTM doesn't read stale items.
 *
 * @param {"page_view"|"view_item"|"add_to_cart"|"begin_checkout"|"purchase"} event
 * @param {AxonEcommercePayload} [ecommerce]
 */
export const gtmPushEcommerce = (event, ecommerce = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  // GA4 best practice: clear the previous ecommerce object before each push.
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event, ecommerce });
};
